import { IController, IScope } from "angular";
import { AuthenticationResolverService } from "@gtmhub/auth";

export interface IUserDeactivatedScope extends IScope {
  transactionID: string;
}

interface IUserDeactivatedStateParams {
  transactionID: string;
}

export class UserDeactivatedCtrl implements IController {
  transactionID: string;

  public static $inject = ["$scope", "$stateParams", "AuthenticationResolverService"];

  constructor(
    private $scope: IUserDeactivatedScope,
    private $stateParams: IUserDeactivatedStateParams,
    private authenticationResolverService: AuthenticationResolverService
  ) {}

  $onInit(): void {
    this.$scope.transactionID = this.$stateParams.transactionID;
    this.authenticationResolverService.signout();
  }
}
